import getTemplates from './get-templates';
import getSingleTemplate from './get-single-template';

const getTemplateBySlug = (rootState, slug) => {
  const singleTemplate = getSingleTemplate(rootState);
  const list = getTemplates(rootState);
  return slug === singleTemplate?.slug
    ? singleTemplate
    : list.find((template) => template.slug === slug);
};

export default getTemplateBySlug;
